import request from '../../api/api';

export default {
	state: () => ({
		eventId: null,
		event: {},
		eventImage: {},
		hashes: { campaignHash: '' },
		ticketConfigurations: [],
		selectedSaleData: [],
		firstSaleData: {},
		userDataFromHash: {}
	}),
	mutations: {
		SET_SALE_DATA(state, selectedSaleData = []) {
			state.selectedSaleData = selectedSaleData;
		},
		SET_USER_DATA_FROM_HASH(state, userDataFromHash = {}) {
			state.userDataFromHash = userDataFromHash;
		},
		SET_FIRST_SALE_DATA(state, firstSaleData = {}) {
			state.firstSaleData = firstSaleData;
		},
		SET_HASH(state, hashes = {}) {
			state.hashes = hashes;
		},
		SET_EVENT_ID(state, eventId) {
			state.eventId = eventId;
		},
		SET_EVENT_DATA(state, event = {}) {
			state.event = event;
		},
		SET_EVENT_IMG(state, eventImage = {}) {
			state.eventImage = eventImage;
		},
		UPDATE_SELECTED_TICKETS(state, { ticketData, ticketTypeId }) {
			const listWithoutSelectedTicket = state.selectedSaleData.filter((conf) => conf.ticketType.id !== ticketTypeId);

			const selectedTicketConf = ticketData.tickets.length
				? state.ticketConfigurations.filter((conf) => conf.ticketType.id === ticketTypeId)
				: [];
			const newTicketData = {
				totalNet: ticketData.totalNet,
				totalPrice: ticketData.totalPrice,
				totalVAT: ticketData.totalVAT,
				tickets: ticketData.tickets,
				promocode: ticketData.promocode,
				promocodeUses: ticketData.promocodeUses
			};

			const ticketWithNewData = selectedTicketConf
				.map((conf) => ({
					...conf,
					...newTicketData
				}))
				.map((conf) => {
					const oneForm = conf.ticketType.oneFormPerSale;
					const selectedForm = conf.form;

					const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

					const tickets = conf.tickets.map((ticket) => {
						const form = !oneForm ? deepClone(selectedForm) : null;
						const ticketId = new Date().getTime() * Math.random() * 100000;
						return { ...ticket, form, ticketId };
					});

					tickets.length && oneForm && (tickets[0].form = deepClone(selectedForm));

					return { ...conf, tickets };
				});
			const ordered = [...listWithoutSelectedTicket, ...ticketWithNewData].sort((a, b) => a.ticketType.id - b.ticketType.id);
			state.selectedSaleData = ordered;
		},
		UPDATE_FORM_HEADER_IN_SELECTED_DATA(state, { rows, ticketTypeId, ticketId }) {
			const listWithoutSelectedTicket = state.selectedSaleData.filter((conf) => conf.ticketType.id !== ticketTypeId);
			const selectedTicketConf = state.selectedSaleData.filter((conf) => conf.ticketType.id === ticketTypeId);

			const ticketWithNewData = selectedTicketConf.map((conf) => {
				const tickets = conf.tickets.map((ticket) => {
					const form = ticket.ticketId === ticketId ? { ...ticket.form, formHeaderLayout: { rows } } : ticket.form;
					return { ...ticket, form };
				});

				return { ...conf, tickets };
			});

			const ordered = [...listWithoutSelectedTicket, ...ticketWithNewData].sort((a, b) => a.ticketType.id - b.ticketType.id);
			state.selectedSaleData = ordered;
		},
		UPDATE_GROUP_ITEMS_IN_SELECTED_DATA(state, { formItemsData, formItemsDataValue, ticketTypeId, ticketId }) {
			const listWithoutSelectedTicket = state.selectedSaleData.filter((conf) => conf.ticketType.id !== ticketTypeId);
			const selectedTicketConf = state.selectedSaleData.filter((conf) => conf.ticketType.id === ticketTypeId);

			const ticketWithNewData = selectedTicketConf.map((conf) => {
				const tickets = conf.tickets.map((ticket) => {
					const checkBox = ticket.ticketId === ticketId ? formItemsData : ticket.checkBox || {};
					const checkBoxValue = ticket.ticketId === ticketId ? formItemsDataValue : ticket.checkBoxValue || {};
					return { ...ticket, checkBox, checkBoxValue };
				});
				return { ...conf, tickets };
			});
			const ordered = [...listWithoutSelectedTicket, ...ticketWithNewData].sort((a, b) => a.ticketType.id - b.ticketType.id);
			state.selectedSaleData = ordered;
		},

		EMPTY_SELECTED_TICKETS(state, { ticketTypeId }) {
			const listWithoutSelectedTicket = state.selectedSaleData.filter((conf) => conf.ticketType.id !== ticketTypeId);
			const ordered = listWithoutSelectedTicket.sort((a, b) => a.ticketType.id - b.ticketType.id);

			state.selectedSaleData = ordered;
		},
		EMPTY_ALL_SELECTED_TICKETS(state) {
			state.selectedSaleData = [];
		},
		SET_TICKET_CONFIGURATIONS(state, ticketConfigurations = []) {
			const ordered = [...state.ticketConfigurations, ...ticketConfigurations].sort((a, b) => a.ticketType.id - b.ticketType.id);

			state.ticketConfigurations = ordered;
		},
		EMPTY_TICKET_CONFIGURATIONS(state) {
			state.ticketConfigurations = [];
			state.selectedSaleData = [];
		},
		UPDATE_RECEIVE_INFORMATION_IN_SELECTED_DATA(state, { value, ticketTypeId, ticketId }) {
			const listWithoutSelectedTicket = state.selectedSaleData.filter((conf) => conf.ticketType.id !== ticketTypeId);
			const selectedTicketConf = state.selectedSaleData.filter((conf) => conf.ticketType.id === ticketTypeId);

			const ticketWithNewData = selectedTicketConf.map((conf) => {
				const tickets = conf.tickets.map((ticket) => {
					if (ticket.ticketId === ticketId) {
						const updateRows = ticket.form.formHeaderLayout.rows.map((row) => {
							return {
								columns: row.columns.map((col) => {
									if (col.attribute === 'receive_information') {
										return { ...col, value };
									} else {
										return col;
									}
								})
							};
						});

						ticket.form.formHeaderLayout.rows = updateRows;
					}

					return { ...ticket };
				});
				return { ...conf, tickets };
			});
			const ordered = [...listWithoutSelectedTicket, ...ticketWithNewData].sort((a, b) => a.ticketType.id - b.ticketType.id);
			state.selectedSaleData = ordered;
		}
	},
	actions: {
		SET_SALE_DATA({ commit }, payload) {
			return commit('SET_SALE_DATA', payload);
		},
		SET_FIRST_SALE_DATA({ commit }, payload) {
			return commit('SET_FIRST_SALE_DATA', payload);
		},
		EMPTY_TICKET_CONFIGURATIONS({ commit }) {
			return commit('EMPTY_TICKET_CONFIGURATIONS');
		},
		SET_EVENT_DATA({ commit }, payload) {
			return commit('SET_EVENT_DATA', payload);
		},
		SET_EVENT_IMG({ commit }, payload) {
			return commit('SET_EVENT_IMG', payload);
		},
		CALCULATE_TICKETS_PRICE({ commit }, { params, ticketTypeId, ticketId, action }) {
			return request.ticketbatch
				.calculateTicketsPrice({ params })
				.then((res) => {
					const ticketData = res.data;
					var containerTicket = document.getElementById("ticket-" + ticketId);
					var promotionalCodeParent = containerTicket.getElementsByClassName("promotional-code-parent")[0];
					var messageTrue = containerTicket.getElementsByClassName("message-detail-promotional-code-true")[0];
					var messageFalse = containerTicket.getElementsByClassName("message-detail-promotional-code-false")[0];
					if (promotionalCodeParent) {
						if (ticketData.tickets.length > 0) {
							promotionalCodeParent.style.display = "block";
							var promotionalCodeApply = ticketData.tickets.some(function(object) {
								return object.withPromocode === true;
							});
							if(messageTrue && messageFalse) {
								if (promotionalCodeApply && action != "button") {	
									messageFalse.style.display = "none";
									messageTrue.style.display = "block";
								} else if (action != "button") {
									messageTrue.style.display = "none";
									messageFalse.style.display = "block";
								} else if (action == "button") {
									messageTrue.style.display = "none";
									messageFalse.style.display = "none";
								}
							}
						} else {
							promotionalCodeParent.style.display = "none";
							messageTrue.style.display = "none";
							messageFalse.style.display = "none";
						}
					}
					
					return commit('UPDATE_SELECTED_TICKETS', { ticketData, ticketTypeId });
				})
				.catch((err) => {
					console.log(err);
					return commit('EMPTY_SELECTED_TICKETS', { ticketTypeId });
				});
		},
		EMPTY_ALL_SELECTED_TICKETS({ commit }) {
			return commit('EMPTY_ALL_SELECTED_TICKETS');
		},
		GET_SALE_DATA({ commit }, { campaignHash }) {
			return request.externalSale.getSaleData({ campaignHash }).then((res) => {
				const data = res.data.ticketConfigurations.map((conf) => {
					const newTicketData = {
						totalNet: 0,
						totalPrice: 0,
						totalVAT: 0,
						tickets: []
					};
					return { ...conf, ...newTicketData };
				});
				const firstData = { ...res.data, ticketConfigurations: [] };
				return Promise.all([
					commit('SET_EVENT_ID', res.data.eventId),
					commit('SET_TICKET_CONFIGURATIONS', data),
					commit('SET_FIRST_SALE_DATA', firstData)
				]);
			});
		},
		GET_EVENT_DATA({ commit, state }) {
			const params = { evenid: state.eventId };

			return Promise.all([
				request.event.getEventData({ params }).then((res) => {
					commit('SET_EVENT_DATA', res.data);
					return res.data;
				}),
				request.event.getEventImg(params).then((res) => {
					commit('SET_EVENT_IMG', res.data[0]);
					return res.data[0];
				})
			]);
		},
		UPDATE_FORM_HEADER_IN_SELECTED_DATA({ commit }, { rows, ticketTypeId, ticketId }) {
			return commit('UPDATE_FORM_HEADER_IN_SELECTED_DATA', { rows, ticketTypeId, ticketId });
		},
		UPDATE_GROUP_ITEMS_IN_SELECTED_DATA({ commit }, { formItemsData, formItemsDataValue, ticketTypeId, ticketId }) {
			return commit('UPDATE_GROUP_ITEMS_IN_SELECTED_DATA', { formItemsData, formItemsDataValue, ticketTypeId, ticketId });
		},
		SET_USER_DATA_FROM_HASH({ commit }, userDataFromHash = {}) {
			return commit('SET_USER_DATA_FROM_HASH', userDataFromHash);
		},
		UPDATE_RECEIVE_INFORMATION_IN_SELECTED_DATA({ commit }, { value, ticketTypeId, ticketId }) {
			return commit('UPDATE_RECEIVE_INFORMATION_IN_SELECTED_DATA', { value, ticketTypeId, ticketId });
		}
	},
	getters: {
		getEvent: (state) => state.event,
		getEventImage: (state) => state.eventImage,
		getTicketConfigurations: (state) => state.ticketConfigurations,
		getTicketsToSale: (state) => state.selectedSaleData,
		loginRequired: (state) => state.selectedSaleData.some((ticket) => ticket.ticketType.externalSaleAuth === true),
		getFirstSaleData: (state) => state.firstSaleData,
		getUserDataFromHash: (state) => state.userDataFromHash,
		isFree: (state) => !state.selectedSaleData.reduce((acc, ticket) => acc + ticket.totalPrice, 0) > 0
	}
};
